import {FormatCurrency, formatFractionalNumber } from '../../functionsGlobal';
import * as  GlobalStyles from '../../shared/GlobalStyles/styles';
import { WrapperDivIcon } from './styles';
import { Table } from '../RenderTable';
import { useTableItems } from '../../hooks/useTableItems';
import { useContext, useState } from 'react';
import { DarkModeContext } from '../../contexts/darkMode';

export const TableItems = (props) => {
    const {
        columns, rows, dragStart, allowDrop, onDrop, handleOrderArray, aggregationSum, isloading,
        handleClick, aggregation, aggregationCount, getRowClassName, onChangeCell, handlersClicks, keyElement, getRowTdClassName
    } = useTableItems(props)
    const [editState, setEditState] = useState({ index: null, field: null });
    const {selectedTheme} = useContext(DarkModeContext)

    if (isloading) return null;

    return (
        <Table.Root>
            <Table.Header>
                <Table.Row>
                    {
                        columns.map((item, index) => (
                            <Table.Column
                            key={'header' + item.field}
                            draggable
                            onDragStart={(e) => dragStart(e, index)}
                            onDragOver={(e) => allowDrop(e, index)}
                            onDrop={(e) => onDrop(e, index)}
                            onClick={() => handleOrderArray(item)}
                            className={getRowTdClassName?.({row:item, index})} 
                            > 
                                <WrapperDivIcon className={getRowTdClassName?.({row:item, index})} >
                                    {item.headerName} 
                                    {
                                        item.order === 'ASC'? (
                                            <GlobalStyles.IconArrowUp key={item.headerName} stroke={selectedTheme.colors.black}/>
                                        ) 
                                        :(
                                            item.order === 'DESC' ? (<GlobalStyles.IconArrowDown key={item.headerName} stroke={selectedTheme.colors.black}/>) 
                                            :(
                                                <GlobalStyles.IconArrowDown key={item.headerName} stroke={'transparent'}/>   
                                            )
                                        )
                                    }
                                </WrapperDivIcon>
                            </Table.Column> 
                        ))
                    }
            
                </Table.Row>
            </Table.Header>
            <Table.Body>  
                {
                    rows.map((productItem, productIndex) => 
                    {
                        return  <Table.Row key ={keyElement !== '' ?  productIndex + 1 : ( (productItem?.id ?? productIndex + 1))} 
                                    className={getRowClassName?.({row:productItem, index:productIndex})}  
                                > 
                        {    
                            columns.map((item, index)=> {
                                const isEditing = editState.index === productIndex && editState.field === item.field;
                                if(item.type === 'number'){
                                    if (item.editable) {
                                        return (
                                            <Table.Td  
                                                key={item?.field ?? index}
                                                onClick={() => setEditState({ index: productIndex, field: item.field })}
                                                className={getRowTdClassName?.({row:item, index})}  
                                            >

                                            {
                                                isEditing ? (
                                                    <input
                                                        value={item?.valueFormatter ? item.valueFormatter(productItem[columns[index].field]) : productItem[columns[index].field] ?? ''}
                                                        onChange={(e) => onChangeCell(productIndex, item.field, e.target.value, item)}
                                                        onBlur={() => setEditState({ index: null, field: null })}
                                                        style={{
                                                        width: '100%',
                                                        border: 'none',
                                                        outline: 'none',
                                                        background: 'transparent',
                                                        color: selectedTheme.colors.black,
                                                        }}

                                                    />
                                                    ):(
                                                        
                                                        columns[index]?.numberWithComma ? formatFractionalNumber(productItem[columns[index].field]) 
                                                        : productItem[columns[index].field]

                                                    )
                                                
                                            }
                                            </Table.Td>
                                        )
                                    }

                                    return <Table.Td  
                                        key={item?.field ?? index}
                                        onClick={() => handleClick(productItem, productIndex)}
                                        className={getRowTdClassName?.({row:item, index})}  
                                    >
                                        {
                                            columns[index]?.numberWithComma ?
                                            formatFractionalNumber(productItem[columns[index].field])
                                            : columns[index].type === 'number' && columns[index].currency !== false ? FormatCurrency(parseFloat(productItem[columns[index].field])) : productItem[columns[index].field]
                                        }
                                    </Table.Td>
                                }
                                if(item.RenderCell !== undefined && item.RenderCell !== null ){
                                    return <Table.Td key={item?.field ?? index} style={{overflow:'visible'}} className={getRowTdClassName?.({row:item, index})}  >
                                        <item.RenderCell index={productIndex} item={productItem} handleClick={handlersClicks} />
                                    </Table.Td>
                                }

                                if (item.editable) {
                                    return (
                                        <Table.Td  
                                            key={item?.field ?? index}
                                            onClick={() => setEditState({ index: productIndex, field: item.field })}
                                        >

                                            {
                                                isEditing ? (
                                            
                                                    <input
                                                        value={item?.valueFormatter ? item.valueFormatter(productItem[columns[index].field]) : productItem[columns[index].field] ?? ''}
                                                        onChange={(e) => onChangeCell(productIndex, item.field, e.target.value, item)}
                                                        onBlur={() => setEditState({ index: null, field: null })}
                                                        style={{
                                                        width: '100%',
                                                        border: 'none',
                                                        outline: 'none',
                                                        background: 'transparent',
                                                        color: selectedTheme.colors.black,
                                                        }}

                                                    />
                                                    ):(
                                                        
                                                        columns[index]?.numberWithComma ? formatFractionalNumber(productItem[columns[index].field]) 
                                                        : productItem[columns[index].field]

                                                    )
                                            }
                                        </Table.Td>

                                    )
                                }

                                else return (<Table.Td  
                                    className={getRowTdClassName?.({row:item, index})}  
                                    key={item?.field ?? index}
                                    onClick={() => handleClick(productItem, productIndex)}
                                >
                                    { 
                            
                                        columns[index]?.numberWithComma ? formatFractionalNumber(productItem[columns[index].field]) 
                                        : productItem[columns[index].field]

                                        
                                    }
                                </Table.Td>)

                            }
                          
                            )
                        } 
                        </Table.Row>  
                    })
                }
            </Table.Body>  
            {
                rows?.length > 0 &&  aggregation?.model && <Table.tfoot>
                    <Table.Row >
                        {
                            columns.map((col) => {
                                const typeAggregation = aggregation?.model[col.field]
                                if(typeAggregation === 'sum') return <Table.Td key={`footer${col.field}`}>{aggregationSum(col.field)}</Table.Td>;
                                if(typeAggregation === 'count') return <Table.Td key={`footer${col.field}`}>{aggregationCount(col.field)}</Table.Td>;
                                return <Table.Td key={`footer${col.field}`}>{null}</Table.Td>;
                            })
                        }

        
                    </Table.Row>
        
                </Table.tfoot>
            }
               

        </Table.Root>
    )
}